import { render, staticRenderFns } from "./SearchResultsBodyPWA.vue?vue&type=template&id=d76a8b20&scoped=true"
import script from "./SearchResultsBodyPWA.vue?vue&type=script&lang=js"
export * from "./SearchResultsBodyPWA.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsBodyPWA.vue?vue&type=style&index=0&id=d76a8b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76a8b20",
  null
  
)

export default component.exports